import { useState } from 'react';
import uuid from 'react-uuid';

import company from '@/assets/img/company.jpg';

import * as S from './style';

const History = () => {
	const [date, setDate] = useState('2020’s');
	const dateList = ['2020’s', '2010’s', '2000’s', '~2000’s'];
	const moveToContent = (tab: string) => {
		requestAnimationFrame(() => {
			const target = document.getElementById(tab)?.offsetTop ?? 0;
			const headerHeight = document.getElementById('header')?.offsetHeight ?? 0;
			const targetScroll = target - headerHeight - 50;
			window.scrollTo({
				top: targetScroll,
			});
		});
	};
	const onClickTabBar = (tab: string) => {
		moveToContent(tab);
		setDate(tab);
	};
	return (
		<S.HistoryContainer>
			<S.HistoryDateList>
				{dateList.map((d) => (
					<S.HistoryDate key={uuid()} className={d === date ? 'active' : ''} onClick={() => onClickTabBar(d)}>
						{d}
					</S.HistoryDate>
				))}
			</S.HistoryDateList>
			<S.HistoryContentWrapper id="2020’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6626031003e5a_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2020’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2025</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>(사)대한화장품학회 5차 정기총회 및 추계학술대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>화장품의날 학회포럼</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2024</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>(사)대한화장품학회 4차 정기총회 및 추계학술대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2023</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>(사)대한화장품학회 3차 정기총회 및 추계학술대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2022</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>(사)대한화장품학회 2차 정기총회 및 추계학술대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2021</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								(사)대한화장품학회 1차 정기총회 및<br />
								추계학술대회 (웨비나 진행)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회(웨비나 진행)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>02월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>사단법인 대한화장품학회로 전환</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentItem>
							<S.HistoryContentTitle>2020</S.HistoryContentTitle>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2020년 추계학술발표대회(웨비나 진행)</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>춘계학술발표대회(웨비나 진행)</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="2010’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F662611ec5330e_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2010’s</S.HistoryContentMainTitle>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2019</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2019년 추계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>44회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2018</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2019년 추계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>43회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentItem>
							<S.HistoryContentTitle>2016</S.HistoryContentTitle>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>23~25일 24th IFSCC Conference 개최</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>42회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2015</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2016년 추계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제40회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2014</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2014년 추계학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>KCII · NCR · SCSK International Symposium</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제39회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2013</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2013년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								2013년 춘계 심포지움
								<br />
								대한화장품학회 워크숍
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제38회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2012</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2012년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제37회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2011</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 36회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한화장품학회 워크숍</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제16대 회장 정해영 교수 취임</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2010</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한화장품학회 워크숍</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2010년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 35회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="2000’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6630a18920417_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>2000’s</S.HistoryContentMainTitle>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2009</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2009년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한화장품학회 워크숍</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>20089년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 34회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2008</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2008년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한화장품학회 워크숍</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2008년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 33회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2007</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2007년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>08월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한화장품학회 워크숍</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2007년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 32회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2006</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2006년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2006년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 31회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2005</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2005년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2005년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 30회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2004</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2004년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 29회 정기총회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2003</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2003년 국제 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2003 IFSCC Conference</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 28회 정기총회 및 학술발표대회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2001</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>2001년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>03월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 26회 정기총회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>2000</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 25회 정기총회</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
			<S.HistoryContentWrapper id="~2000’s">
				<S.HistoryImgBox bgImg={'//cdn.quv.kr/dftb6osy3%2Fup%2F6630a1dda7062_1920.jpg'} />
				<S.HistoryContentBox>
					<S.HistoryContentMainTitle>~2000’s</S.HistoryContentMainTitle>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1999</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1999년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1998</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1998년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1997</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>05월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1997년 춘계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1996</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1996년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1995</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>06월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>제 2차 아시아화장품과학자대회개최</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1994</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>07월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1994년 하계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1993</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1993년 춘계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1992</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>11월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>대한한화장품학회로 명칭변경</S.HistoryContentDescription>
						</S.HistoryContentItem>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>09월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>1992년 추계 심포지움</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1991</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>편집, 재무, 운영 및 학술위원회로 조직 개편</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1970</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>04월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								제 1회 정기총회
								<br />
								화장품화학회지 창간호 발행
								<br />
								한국화장품화학자회로 명칭변경
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>

					<S.HistoryContentItemBox>
						<S.HistoryContentTitle>1968</S.HistoryContentTitle>
						<S.HistoryContentItem>
							<S.HistoryContentSubTitle>10월</S.HistoryContentSubTitle>
							<S.HistoryContentDescription>
								한국화장품화학기술자회 발족
								<br />
								회장: 구용섭, 태평양화학(주)
							</S.HistoryContentDescription>
						</S.HistoryContentItem>
					</S.HistoryContentItemBox>
				</S.HistoryContentBox>
			</S.HistoryContentWrapper>
		</S.HistoryContainer>
	);
};
export default History;
